import type { OrganizationType } from '@common/enums';
import { OrganizationTypeWithLinkedProfessions } from '@common/enums';

export function convertOrganizationTypeToOrganizationTypeWithLinkedProfessions(
    organizationType: OrganizationType
): OrganizationTypeWithLinkedProfessions | null {
    return Object.values(OrganizationTypeWithLinkedProfessions).includes(
        organizationType as OrganizationTypeWithLinkedProfessions
    )
        ? (organizationType as OrganizationTypeWithLinkedProfessions)
        : null;
}
